var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInvoices = function SvgInvoices(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "invoices_svg2__a",
    x1: -10.94,
    x2: 103.76,
    y1: 206.45,
    y2: 101.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#invoices_svg2__a",
    id: "invoices_svg2__c",
    x1: -3.69,
    x2: 111.01,
    y1: 214.38,
    y2: 109.51
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#invoices_svg2__a",
    id: "invoices_svg2__d",
    x1: 14.42,
    x2: 129.12,
    y1: 234.19,
    y2: 129.31
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#invoices_svg2__a",
    id: "invoices_svg2__e",
    x1: 13.42,
    x2: 128.12,
    y1: 233.1,
    y2: 128.22
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#invoices_svg2__a",
    id: "invoices_svg2__f",
    x1: 31.53,
    x2: 146.23,
    y1: 252.9,
    y2: 148.03
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#invoices_svg2__a",
    id: "invoices_svg2__g",
    x1: 39.42,
    x2: 154.13,
    y1: 261.54,
    y2: 156.67
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#invoices_svg2__a",
    id: "invoices_svg2__h",
    x1: -14.02,
    x2: 100.68,
    y1: 203.08,
    y2: 98.21
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#invoices_svg2__a",
    id: "invoices_svg2__i",
    x1: -56.22,
    x2: 58.49,
    y1: 156.93,
    y2: 52.06
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M169.95 61.09H76.48c-5.43 0-9.84 4.43-9.84 9.87v25.71c0 5.41 4.4 9.82 9.82 9.82h93.5c5.43 0 9.84-4.4 9.84-9.82V70.94c0-5.43-4.42-9.84-9.84-9.84Zm3.78 35.58c0 2.07-1.7 3.75-3.78 3.75h-93.5c-2.07 0-3.75-1.68-3.75-3.75V70.96c0-2.1 1.7-3.8 3.78-3.8h93.47c2.08 0 3.78 1.69 3.78 3.78z",
    style: {
      fill: "url(#invoices_svg2__a)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.36 147.39h14.68c4.08 0 7.39-3.31 7.39-7.39v-14.68c0-4.08-3.32-7.39-7.39-7.39H78.36c-4.08 0-7.39 3.32-7.39 7.39V140c0 4.07 3.32 7.39 7.39 7.39m-1.33-22.07c0-.73.6-1.33 1.33-1.33h14.68c.73 0 1.33.6 1.33 1.33V140c0 .73-.6 1.33-1.33 1.33H78.36c-.73 0-1.33-.6-1.33-1.33z",
    style: {
      fill: "url(#invoices_svg2__c)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.73 153.66H79.05c-4.08 0-7.39 3.31-7.39 7.39v14.68c0 4.08 3.31 7.39 7.39 7.39h14.68c4.08 0 7.39-3.32 7.39-7.39v-14.68c0-4.07-3.31-7.39-7.39-7.39m1.33 22.07c0 .73-.6 1.33-1.33 1.33H79.05c-.73 0-1.33-.6-1.33-1.33v-14.68c0-.73.6-1.33 1.33-1.33h14.68c.73 0 1.33.6 1.33 1.33z",
    style: {
      fill: "url(#invoices_svg2__d)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.93 147.39h14.69c4.08 0 7.39-3.31 7.39-7.39v-14.68c0-4.08-3.31-7.39-7.39-7.39h-14.69c-4.08 0-7.39 3.32-7.39 7.39V140c0 4.07 3.32 7.39 7.39 7.39m-1.33-22.07c0-.73.6-1.33 1.33-1.33h14.69c.73 0 1.33.6 1.33 1.33V140c0 .73-.6 1.33-1.33 1.33h-14.69c-.73 0-1.33-.6-1.33-1.33z",
    style: {
      fill: "url(#invoices_svg2__e)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.3 153.66h-14.68c-4.08 0-7.39 3.31-7.39 7.39v14.68c0 4.08 3.32 7.39 7.39 7.39h14.68c4.08 0 7.39-3.32 7.39-7.39v-14.68c0-4.07-3.32-7.39-7.39-7.39m1.34 22.07c0 .73-.6 1.33-1.33 1.33h-14.68c-.73 0-1.33-.6-1.33-1.33v-14.68c0-.73.6-1.33 1.33-1.33h14.68c.73 0 1.33.6 1.33 1.33z",
    style: {
      fill: "url(#invoices_svg2__f)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.19 117.92h-14.68c-4.08 0-7.39 3.31-7.39 7.39v50.41c0 4.08 3.31 7.39 7.39 7.39h14.68c4.08 0 7.39-3.32 7.39-7.39v-50.41c0-4.08-3.32-7.39-7.39-7.39m1.33 57.8c0 .73-.6 1.33-1.33 1.33h-14.68c-.73 0-1.33-.6-1.33-1.33v-50.41c0-.73.6-1.33 1.33-1.33h14.68c.73 0 1.33.6 1.33 1.33z",
    style: {
      fill: "url(#invoices_svg2__g)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.22 48.76h-19.58V12.74c0-7.03-5.72-12.74-12.75-12.74H20.6C13.59 0 7.88 5.71 7.88 12.74v174.53c0 7.01 5.7 12.72 12.71 12.72h50.33c.09 0 .17.01.26.01h104.03c9.32 0 16.89-7.59 16.89-16.92V65.68c0-9.33-7.58-16.92-16.89-16.92ZM32.68 75.81H54.3v14.93H32.68c-1.67 0-3.03 1.36-3.03 3.03s1.36 3.03 3.03 3.03H54.3v14.93H32.68c-1.67 0-3.03 1.36-3.03 3.03s1.36 3.03 3.03 3.03H54.3v14.93H32.68c-1.67 0-3.03 1.36-3.03 3.03s1.36 3.03 3.03 3.03H54.3v14.93H32.68c-1.67 0-3.03 1.36-3.03 3.03s1.36 3.03 3.03 3.03H54.3v23.3c0 .97.1 1.92.26 2.85.02.09.02.18.04.26.17.89.41 1.76.71 2.6.04.1.07.21.11.31.32.83.69 1.64 1.14 2.4.04.07.08.13.12.2.47.79.98 1.54 1.57 2.24H20.6c-3.67 0-6.65-2.98-6.65-6.65V12.74c0-3.68 2.98-6.68 6.65-6.68h122.3c3.68 0 6.68 3 6.68 6.68v36.02H32.68c-1.67 0-3.03 1.36-3.03 3.03s1.36 3.03 3.03 3.03h25.58a16.83 16.83 0 0 0-3.96 10.86v4.07H32.68c-1.67 0-3.03 1.36-3.03 3.03s1.36 3.03 3.03 3.03m153.37 107.27c0 5.99-4.86 10.86-10.83 10.86H71.25s-.04-.01-.07-.01c-5.97 0-10.83-4.87-10.83-10.86V65.69c0-5.99 4.86-10.86 10.83-10.86h104.03c5.97 0 10.83 4.87 10.83 10.86v117.4Z",
    style: {
      fill: "url(#invoices_svg2__h)",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.68 33.82h98.14c1.67 0 3.03-1.36 3.03-3.03s-1.36-3.03-3.03-3.03H32.68c-1.67 0-3.03 1.36-3.03 3.03s1.35 3.03 3.03 3.03",
    style: {
      fill: "url(#invoices_svg2__i)",
      strokeWidth: 0
    }
  }));
};
export default SvgInvoices;